import { render, staticRenderFns } from "./PerfectJourney.vue?vue&type=template&id=9bc823fc&scoped=true&"
import script from "./PerfectJourney.vue?vue&type=script&lang=js&"
export * from "./PerfectJourney.vue?vue&type=script&lang=js&"
import style0 from "./PerfectJourney.vue?vue&type=style&index=0&id=9bc823fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc823fc",
  null
  
)

/* custom blocks */
import block0 from "./PerfectJourney.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports